export default __webpack_public_path__ + "static/media/more9.e0553299.jpeg";